
































































import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api/apiclient';
import { emailRegexp } from '@/helpers/validation';
import MediaAlert from "@/components/MediaAlert.vue";

@Component({
  components: {MediaAlert}
})
export default class ContactsForm extends Vue {

  @Prop({ default: '/cms/api/contacts/send' })
  private action!: string;

  private form = {
    roboname: '',
    robochk: false,
    name: '',
    email: '',
    contact: '',
    message: ''
  }

  private sending = false;
  private showSuccess = 0;
  private showError = 0;
  private errorMessage = '';

  emailState() {
    return this.form.email && !this.form.email.match(emailRegexp) ? false : null;
  }

  valid() {
    return this.form.name && this.form.message && this.form.email.match(emailRegexp);
  }

  mounted() {
    const guest: { name: string, email: string, contact: string } = this.$cookies.get('guest');
    if (guest) {
      this.form = Object.assign({}, this.form, guest);
    }
  }

  onSubmit(e: Event) {
    e.preventDefault();

    this.$cookies.set('guest', {
      name: this.form.name,
      email: this.form.email,
      contact: this.form.contact
    });

    if (!this.valid()) return false;

    this.sending = true;
    api.post<{ message: string }>(this.action, this.form)
    .then(data => {
      this.showSuccess = 5;
      this.form.message = '';
    })
    .catch(e => {
      this.errorMessage = e.response?.data?.message || '';
      this.showError = 10
    })
    .finally(() => this.sending = false);

    return false;
  }
}
